import React, { useEffect, useState, useContext } from 'react';

import Transactions from './Transactions';
import Participated from './Participated';
import BusinessRank from './BusinessRank';
import RankBaseQuestion from './RankBaseQuestion';
import Services from './Services';
import Users from './Users';
import Sales from './Sales';
import UsesServices from './UsesServices';
import Changes from './Changes';
import RankBusinessQuestion from './RankBusinessQuestion';
import RankOpinionQuestion from './RankOpinionQuestion';
import RankOpinionBusiness from './RankOpinionBusiness';
import { Context } from '../../context/UserContext';
import OpinionSMS from './OpinionSMS';

const ReportOpinion = () => {

    const context = useContext(Context);
    const [currentTab, setCurrentTab] = useState('participated');

    let userData = localStorage.getItem('user') != null ? JSON.parse(localStorage.getItem('user')).roleId : {};

    useEffect(() => {
        setCurrentTab(userData === 3 ? 'rankBaseQuestion' : "participated")
    }, [])

    return (
        <div className="card">
            <div className="card-header"><div className="card-title">گزارشات نظرسنجی </div></div>
            <div className="card-body">

                <div className="row mb-5">
                    {userData !== 3 && <> {context.checkHasPermission('read', 20) ? <div className="col-md-1 d-grid">
                        <button onClick={e => setCurrentTab('participated')} className={currentTab == 'participated' ? 'btn btn-info' : 'btn btn-info-light'}>نظرسنجی</button>
                    </div> : ""}</>}
                    {userData !== 3 && <>   <div className="col-md-2 d-grid">
                        <button onClick={e => setCurrentTab('businessRank')} className={currentTab == 'businessRank' ? 'btn btn-info' : 'btn btn-info-light'}>نمودار امتیاز کسب و کار ها</button>
                    </div>   </>}
                    {/* {context.checkHasPermission('read', 20) ?  */}<div className="col-md-2 d-grid">
                        <button onClick={e => setCurrentTab('rankBaseQuestion')} className={currentTab == 'rankBaseQuestion' ? 'btn btn-info' : 'btn btn-info-light'}>امتیاز سوالات کسب و کارها </button>
                    </div>{/*  : ''} */}
                    {userData !== 3 && <>    {context.checkHasPermission('read', 20) ? <div className="col-md-2 d-grid">
                        <button onClick={e => setCurrentTab('rankBusinessQuestion')} className={currentTab == 'rankBusinessQuestion' ? 'btn btn-info' : 'btn btn-info-light'}>  نمودار امتیاز سوالات کسب و کارها </button>
                    </div> : ''}</>}
                    {userData !== 3 && <>  {context.checkHasPermission('read', 20) ? <div className="col-md-2 d-grid">
                        <button onClick={e => setCurrentTab('rankOpinionQuestion')} className={currentTab == 'rankOpinionQuestion' ? 'btn btn-info' : 'btn btn-info-light'}>  نمودار امتیاز سوال نظرسنجی</button>
                    </div> : ''}</>}
                    {/*  {context.checkHasPermission('read', 20) ? */} <div className="col-md-2 d-grid">
                        <button onClick={e => setCurrentTab('rankOpinionBusiness')} className={currentTab == 'rankOpinionBusiness' ? 'btn btn-info' : 'btn btn-info-light'}>    نمودار امتیاز کسب و کار نظرسنجی </button>
                    </div> {/* : ''} */}

                </div>

                <div className="row">
                    <div className="col-12">
                        <div className="card mb-0">
                            <div className="card-body report-card" style={{ background: '#f0f0f0', borderRadius: 7 }}>
                                {userData !== 3 && <>  {currentTab == 'participated' ? <Participated /> : ''} </>}
                                {currentTab == 'businessRank' ? <BusinessRank /> : ''}
                                {currentTab == 'rankBaseQuestion' ? <RankBaseQuestion /> : ''}
                                {currentTab == 'services' ? <Services /> : ''}
                                {currentTab == 'users' ? <Users /> : ''}
                                {currentTab == 'sales' ? <Sales /> : ''}
                                {currentTab == 'uses_services' ? <UsesServices /> : ''}
                                {currentTab == 'changes' ? <Changes /> : ''}
                                {currentTab == 'rankBusinessQuestion' ? <RankBusinessQuestion /> : ''}
                                {currentTab == 'rankOpinionQuestion' ? <RankOpinionQuestion /> : ''}
                                {currentTab == 'rankOpinionBusiness' ? <RankOpinionBusiness /> : ''}
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    );
}

export default ReportOpinion;